import GameModel from "../../GameModel";
import BigNum from "../math/BigNum";

export default class SkillNodePurchaseListener extends GameModel {
    constructor() {
        super();
    }

    /**
     * @abstract
     * @param {BigNum} pointsSpent
     */
    onNodePurchased(pointsSpent) {
    }

    /**
     * @abstract
     */
    onNodePurchasedFromSave() {
    }

}